import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(`API Error: ${error.response?.status} ${error.config?.url}`, error.response?.data);
    return Promise.reject(error);
  }
);

// API functions
export const categoriesAPI = {
  getAll: async () => {
    const response = await apiClient.get('/categories');
    return response.data;
  },
};

export const projectsAPI = {
  getBySubcategory: async (categoryType, subcategoryId) => {
    const response = await apiClient.get(`/projects/${categoryType}/${subcategoryId}`);
    return response.data;
  },
  
  search: async (query, categoryType = null, subcategory = null) => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    if (categoryType) params.append('category', categoryType);
    if (subcategory) params.append('subcategory', subcategory);
    
    const response = await apiClient.get(`/projects/search?${params.toString()}`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await apiClient.get(`/projects/${id}`);
    return response.data;
  },
  
  create: async (projectData) => {
    const response = await apiClient.post('/projects', projectData);
    return response.data;
  },
  
  update: async (id, projectData) => {
    const response = await apiClient.put(`/projects/${id}`, projectData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await apiClient.delete(`/projects/${id}`);
    return response.data;
  },
};

export default apiClient;